export enum UserRoles {
  USER = 'user',
  ADMIN = 'admin',
  GUEST = 'guest',
  OPERATOR = 'operator',
  SUPERVISOR = 'supervisor',
}

export type User = {
  email: string
  password?: string
  role: UserRoles
  isConfirmed: boolean
  name: string
  surname: string
  isEnabled: boolean
  isDeleted: boolean
  _id: string
}
